export const GETMANUFACTURER_SUCCESS = "GETMANUFACTURER_SUCCESS";
export const GETMANUFACTURER_ERROR = "GETMANUFACTURER_ERROR";

export const CHANGEACTION_SUCCESS = "CHANGEACTION_SUCCESS";
export const CHANGEACTION_ERROR = "CHANGEACTION_ERROR";

export const APPROVAL_SUCCESS = "APPROVAL_SUCCESS";
export const APPROVAL_ERROR = "APPROVAL_ERROR";


